import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

class MentionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error for debugging
    console.error('Mention component error:', error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });

    // Report to error tracking service if available
    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: `Mention Error: ${error.message}`,
        fatal: false
      });
    }
  }

  handleRetry = () => {
    this.setState({ 
      hasError: false, 
      error: null, 
      errorInfo: null 
    });
  };

  render() {
    if (this.state.hasError) {
      // Render fallback UI based on component type
      const { fallbackType = 'inline', children } = this.props;
      
      if (fallbackType === 'dropdown') {
        return (
          <div className="p-4 text-center bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg shadow-lg">
            <ExclamationTriangleIcon className="h-8 w-8 text-red-500 mx-auto mb-2" />
            <p className="text-sm text-red-600 dark:text-red-400 mb-2">
              User search temporarily unavailable
            </p>
            <button
              onClick={this.handleRetry}
              className="text-xs text-purple-600 hover:text-purple-800 dark:text-purple-400 dark:hover:text-purple-300"
            >
              Try again
            </button>
          </div>
        );
      }
      
      if (fallbackType === 'mention') {
        // For individual mention rendering errors
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-md text-sm bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-700">
            <ExclamationTriangleIcon className="h-3 w-3 mr-1" />
            @[Error]
          </span>
        );
      }
      
      // Default inline fallback
      return (
        <div className="inline-flex items-center px-3 py-2 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-md">
          <ExclamationTriangleIcon className="h-4 w-4 text-red-500 mr-2" />
          <span className="text-sm text-red-700 dark:text-red-300">
            Mention feature temporarily unavailable
          </span>
          <button
            onClick={this.handleRetry}
            className="ml-2 text-xs text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 underline"
          >
            Retry
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default MentionErrorBoundary;